// AdminSubmissions.jsx
import React, { useEffect, useState } from 'react';
import axios from 'axios';

const AdminSubmissions = () => {
  const [pendingSubmissions, setPendingSubmissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedSubmission, setSelectedSubmission] = useState(null);

  useEffect(() => {
    fetchPendingSubmissions();
  }, []);

  const fetchPendingSubmissions = async () => {
    try {
      const token = localStorage.getItem('adminToken');
      const response = await axios.get(
        'https://keurgui-backend-kjour.ondigitalocean.app/api/admin/pending-submissions',
        { headers: { 'Authorization': `Bearer ${token}` } }
      );
      setPendingSubmissions(response.data);
    } catch (error) {
      console.error('Erreur:', error);
      alert('Erreur lors du chargement des soumissions');
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (submissionId) => {
    if (!window.confirm('Approuver cette propriété ? Elle sera publiée immédiatement.')) {
      return;
    }

    try {
      const token = localStorage.getItem('adminToken');
      await axios.post(
        `https://keurgui-backend-kjour.ondigitalocean.app/api/admin/approve-submission/${submissionId}`,
        {},
        { headers: { 'Authorization': `Bearer ${token}` } }
      );
      
      alert('✅ Propriété approuvée et publiée avec succès !');
      fetchPendingSubmissions(); // Rafraîchir la liste
      setSelectedSubmission(null);
    } catch (error) {
      alert('❌ Erreur lors de l\'approbation');
    }
  };

  const handleReject = async (submissionId) => {
    const reason = prompt('Veuillez indiquer la raison du rejet :');
    if (!reason) return;

    try {
      const token = localStorage.getItem('adminToken');
      await axios.put(
        `https://keurgui-backend-kjour.ondigitalocean.app/api/admin/reject-submission/${submissionId}`,
        { reason },
        { headers: { 'Authorization': `Bearer ${token}` } }
      );
      
      alert('❌ Propriété rejetée');
      fetchPendingSubmissions(); // Rafraîchir la liste
      setSelectedSubmission(null);
    } catch (error) {
      alert('Erreur lors du rejet');
    }
  };

  if (loading) return <div>Chargement des soumissions...</div>;

  return (
    <div className="admin-submissions">
      <h2>Soumissions en attente d'approbation</h2>
      
      {pendingSubmissions.length === 0 ? (
        <p>Aucune soumission en attente</p>
      ) : (
        <div className="submissions-list">
          {pendingSubmissions.map(submission => (
            <div key={submission._id} className="submission-card">
              <h3>{submission.title}</h3>
              <p><strong>Agent:</strong> {submission.submittedBy?.agentName}</p>
              <p><strong>Prix:</strong> {submission.price} FCFA</p>
              <p><strong>Type:</strong> {submission.transactionType}</p>
              <p><strong>Soumis le:</strong> {new Date(submission.createdAt).toLocaleDateString()}</p>
              
              <div className="actions">
                <button 
                  onClick={() => setSelectedSubmission(submission)}
                  className="btn-view"
                >
                  Voir détails
                </button>
                <button 
                  onClick={() => handleApprove(submission._id)}
                  className="btn-approve"
                >
                  ✅ Approuver
                </button>
                <button 
                  onClick={() => handleReject(submission._id)}
                  className="btn-reject"
                >
                  ❌ Rejeter
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Modal de détails */}
      {selectedSubmission && (
        <div className="modal">
          <div className="modal-content">
            <h3>Détails de la propriété</h3>
            <button onClick={() => setSelectedSubmission(null)}>Fermer</button>
            
            <div className="property-details">
              <p><strong>Titre:</strong> {selectedSubmission.title}</p>
              <p><strong>Description:</strong> {selectedSubmission.description}</p>
              <p><strong>Prix:</strong> {selectedSubmission.price} FCFA</p>
              <p><strong>Adresse:</strong> {selectedSubmission.address}, {selectedSubmission.city}</p>
              <p><strong>Chambres:</strong> {selectedSubmission.features.bedrooms}</p>
              <p><strong>Salles de bain:</strong> {selectedSubmission.features.bathrooms}</p>
              
              <div className="images">
                {selectedSubmission.images.map((img, idx) => (
                  <img key={idx} src={img} alt={`property-${idx}`} width="200" />
                ))}
              </div>
            </div>
            
            <div className="modal-actions">
              <button onClick={() => handleApprove(selectedSubmission._id)}>
                Approuver
              </button>
              <button onClick={() => handleReject(selectedSubmission._id)}>
                Rejeter
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminSubmissions;